import { Injectable } from '@angular/core';
import { API_ENDPOINTS } from '../constants/api-endpoints';
import { LoginResponse } from '../models/logininterface';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

import { CsrfTokenService } from '../security/csrf.service';
import { BaseService } from '../security/base.service';
import { AUTH_SESSION_HEADER } from '../auth/auth-session';


@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private http: HttpClient,
    private csrf:CsrfTokenService
  ) { }
  
  login(payload:any): Observable<LoginResponse>
  {
    return this.http.post<any>(API_ENDPOINTS.AUTH.ADMINLOGIN,payload, { withCredentials: true });
  }
  agentLogin(payload:any): Observable<LoginResponse>
  {
    return this.http.post<any>(API_ENDPOINTS.AUTH.AGENTLOGIN,payload, { withCredentials: true });
  }

  changePassword(payload:any): Observable<any> {
      const encodedPayload = {
        emailID: payload.emailID,
        currentPassword: BaseService.toBase64(payload.currentPassword),
        newPassword: BaseService.toBase64(payload.newPassword),
        isAgent:payload.isAgent
      };
    return this.http.post(API_ENDPOINTS.AUTH.CHANGE_PASSWORD, encodedPayload);
  }

  setpassword(password: string, token: string): Observable<any> {
    return this.http.post(API_ENDPOINTS.AUTH.USER_RESET_PASSWORD, {
      NewPassword: BaseService.toBase64(password),
      token: token
    });
  }
  userresetPassword(token: string, newPassword: string): Observable<any> {
    const encodednewPassword = BaseService.toBase64(newPassword);
    return this.http.post(API_ENDPOINTS.AUTH.USER_RESET_PASSWORD, {
      token,
      NewPassword:encodednewPassword,
    });
  }
   resetPassword(userName: string, newPassword: string, isAgent: boolean): Observable<any> {
   
    const encodednewPassword = BaseService.toBase64(newPassword);
    const payload = {
      userName : userName,
      newPassword : encodednewPassword,
      IsAgent: isAgent
    };
    return this.http.post(API_ENDPOINTS.AUTH.RESET_PASSWORD, payload);
  }

  forgotpassword(email:string){
    return this.http.post(API_ENDPOINTS.AUTH.FORGOT_PASSWORD(email),null);
  }

  getLoginSlider() {
    return this.http.get<any>(API_ENDPOINTS.LOGINSLIDER.GET_LATESTSLIDER, {
      headers: {
        'X-Skip-Loader': 'true'
      }
    });
  }
  RefreshToken(payload: any) {
    return this.http.post<any>(
      API_ENDPOINTS.AUTH.REFRESH_TOKEN,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          'X-Skip-Auth': 'true',
          'X-Skip-Loader': 'true'
        },
        withCredentials: true
      }
    );
  }

  logout(accessToken?: string, csrfToken?: string, sessionId?: string): Observable<any> {
    const headers: Record<string, string> = {
      'X-Skip-Loader': 'true',
      'X-Skip-Refresh': 'true'
    };
    // AuthService clears local state immediately; this immutable snapshot still
    // identifies the session that must be revoked before navigation unloads XHR.
    if (accessToken) headers['Authorization'] = `Bearer ${accessToken}`;
    if (csrfToken) headers['X-CSRF-TOKEN'] = csrfToken;
    if (sessionId) headers[AUTH_SESSION_HEADER] = sessionId;
    return this.http.post(
      API_ENDPOINTS.AUTH.LOGOUT,
      null,
      {
        headers,
        withCredentials: true
      }
    );
  }

}
